;
export default {
    // 系统列表查询接口
    listSysInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/listSysList', params, response);
    },
    // 系统删除接口
    deleteSysInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/deleteSysInfo', params, response);
    },
    // 系统添加接口
    insertSysInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/insertUpdateSysInfo', params, response);
    },
    // 系统更新接口
    updateSysInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/insertUpdateSysInfo', params, response);
    },
    destroy() {
        apiAxios.destroy();
        // apiAxios = null;
    }
};
